import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralCurrentRankMinDepositByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': 'テーマ',
  'common.themeLight': 'ライト',
  'common.themeDark': 'ダーク',
  'common.themeActive': '現在適用中',
  'common.themeSwitchToDark': 'ダークに切り替え',
  'common.themeSwitchToLight': 'ライトに切り替え',
  'common.settings': '設定',
  'common.loading': '読み込み中…',
  'settings.language': '言語',
  'settings.savePreferences': '設定を保存',
  'settings.savingPreferences': '保存中…',
  'auth.gate.userTitle': 'セッションを確認中',
  'auth.gate.userDescription': 'ログインを確認しています。少々お待ちください。',
  'auth.gate.agentTitle': 'セッションを確認中',
  'auth.gate.agentDescription': 'エージェントログインを確認しています。',
  'user.layout.sidebarTitle': 'MineMe ユーザーパネル',
  'user.layout.logout': 'ログアウト',
  'user.layout.nav.dashboard': 'ダッシュボード',
  'user.layout.nav.deposit': '入金',
  'user.layout.nav.withdraw': '出金',
  'user.layout.nav.investments': '投資',
  'user.layout.nav.referral': '紹介',
  'user.layout.nav.notifications': '通知',
  'user.layout.nav.stopLoss': 'ストップロス',
  'user.layout.nav.transactions': '取引',
  'user.layout.nav.settings': '設定',
  'user.layout.balance.available': '利用可能残高',
  'user.layout.balance.frozen': '凍結残高',
  'user.layout.balance.interest': '利息残高',
  'user.layout.balance.bonus': 'ボーナス残高',
  'user.dashboard.balance.available': '利用可能残高',
  'user.dashboard.balance.frozen': '凍結残高',
  'user.dashboard.balance.interest': '獲得利息',
  'user.dashboard.balance.bonus': 'ボーナス残高',

  'common.time.days': '日',
  'common.time.hours': '時間',
  'common.time.minutes': '分',
  'common.time.seconds': '秒',

  'user.dashboard.title': 'ダッシュボード',
  'user.dashboard.loadingInvestments': '投資状況を読み込み中…',
  'user.dashboard.stats.totalInvested': '投資累計',
  'user.dashboard.stats.netPnl': '純損益',
  'user.dashboard.stats.activePlans': 'アクティブなプラン',
  'user.dashboard.noInvestment.title': 'アクティブな投資はありません',
  'user.dashboard.noInvestment.subtitle': '今すぐ投資を始め、魅力的なリターンで資産を増やしましょう',
  'user.dashboard.noInvestment.cta': '投資プランを見る',
  'user.dashboard.recentTx.title': '最近の取引',
  'user.dashboard.recentTx.viewAll': 'すべて表示',
  'user.dashboard.recentTx.col.date': '日付',
  'user.dashboard.recentTx.col.type': '種類',
  'user.dashboard.recentTx.col.description': '説明',
  'user.dashboard.recentTx.col.amount': '金額',
  'user.dashboard.recentTx.col.status': 'ステータス',
  'user.dashboard.recentTx.loading': '最近の取引を読み込み中…',
  'user.dashboard.recentTx.empty': '最近の取引はありません。',
  'user.dashboard.tx.Deposit': '入金',
  'user.dashboard.tx.Investment': '投資',
  'user.dashboard.tx.Referral': '紹介',
  'user.dashboard.tx.Bonus': 'ボーナス',
  'user.dashboard.tx.Withdrawal': '出金',
  'user.dashboard.tx.E-Voucher': '電子バウチャー',
  'user.dashboard.tx.Stop-Loss': 'ストップロス',
  'user.dashboard.st.Completed': '完了',
  'user.dashboard.st.Active': 'アクティブ',
  'user.dashboard.st.Pending': '保留中',
  'user.dashboard.st.Failed': '失敗',
  'user.dashboard.invest.planFallback': 'プラン',
  'user.dashboard.invest.activeBadge': 'アクティブ',
  'user.dashboard.invest.detail.amountInvested': '投資金額',
  'user.dashboard.invest.detail.currentValue': '現在価値',
  'user.dashboard.invest.detail.pl': '損益',
  'user.dashboard.invest.detail.interestRate': '金利',
  'user.dashboard.invest.detail.perMonth': '月 {{pct}}%',
  'user.dashboard.invest.detail.duration': '期間',
  'user.dashboard.invest.detail.months': '{{n}} か月',
  'user.dashboard.invest.detail.startDate': '開始日',
  'user.dashboard.invest.detail.nextWithdrawal': '次回出金',
  'user.dashboard.invest.countdownTitle': '次回出金まで',
  'user.dashboard.invest.progress': '進捗',
  'user.dashboard.invest.progressPct': '{{pct}}% 完了',
  'user.dashboard.invest.earlyWithdraw': '早期出金',
  'user.dashboard.invest.planChip': '{{name}} 第{{num}}件',
  'user.dashboard.invest.modal.title': '注意：早期出金',
  'user.dashboard.invest.modal.investmentAmount': '投資金額：',
  'user.dashboard.invest.modal.platformFee': 'プラットフォーム手数料（{{pct}}%）：',
  'user.dashboard.invest.modal.interestForfeited': '放棄する利息：',
  'user.dashboard.invest.modal.youWillReceive': '受取予定額：',
  'user.dashboard.invest.modal.confirmHint': '続行するには CONFIRM と入力',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': '出金を確認',
  'user.dashboard.invest.modal.cancelling': 'キャンセル中…',
  'user.dashboard.invest.toast.cancelled': '投資をキャンセルしました',
  'user.dashboard.invest.toast.cancelFailed': 'キャンセルに失敗しました',

  'notifications.bell.triggerAria': '通知',
  'notifications.bell.title': '通知',
  'notifications.bell.loading': '読み込み中…',
  'notifications.bell.loadErrorSubtitle': '通知を読み込めませんでした',
  'notifications.bell.unreadOne': '未読の更新が 1 件',
  'notifications.bell.unreadMany': '未読の更新が {{count}} 件',
  'notifications.bell.allCaughtUp': '最新の状態です',
  'notifications.bell.markAllRead': 'すべて既読にする',
  'notifications.bell.empty': '通知はまだありません',
  'notifications.bell.emptyError': '通知を読み込めませんでした',
  'notifications.bell.viewAll': 'すべて表示',
  'notifications.bell.markReadAria': '既読にする',
  'notifications.bell.time.justNow': 'たった今',
  'notifications.bell.time.secondsAgo': '{{n}} 秒前',
  'notifications.bell.time.minutesAgo': '{{n}} 分前',
  'notifications.bell.time.hoursAgo': '{{n}} 時間前',
  'notifications.bell.time.daysAgo': '{{n}} 日前',

  'agent.layout.logout': 'ログアウト',
  'agent.layout.nav.dashboard': 'ダッシュボード',
  'auth.user.login.title': 'ユーザーログイン',
  'auth.user.login.signIn': 'ログイン',
  'auth.agent.login.title': 'エージェントログイン',
  'auth.agent.login.signIn': 'ログイン',

  ...panelSettingsTransactionsByLang.ja,
  ...panelReferralCurrentRankMinDepositByLang.ja,
  ...panelUserExtraByLang.ja,
  ...panelDwiOverrides.ja,
  ...panelDepositBonusByLang.ja,
  ...panelVoucherStatusByLang.ja,
  ...panelWithdrawBep20ByLang.ja,
  ...panelDepositVoucherOverrides.ja,
  ...panelInvestmentsOverrides.ja,
  'user.investments.card.dailyProfit': '日次利益',
  'user.investments.card.earningDays': '営業日',
  'user.investments.card.earningDaysValue': '営業日 {{count}} 日',
  'user.investments.card.expectedProfit': '予想利益',
  'user.investments.card.investLimit': '投資上限',
  'user.investments.card.investLimitLine': '{{days}}日間で{{count}}回',
  'user.investments.card.investLimitReached':
    '現在の期間におけるこのプランの投資上限に達しました。',
  'user.investments.card.limitReached': '上限に達しました',
  ...panelStopLossSlotsAssignOverrides.ja,
  ...panelStopLossFlowByLang.ja,
  ...panelUserSignupSocialForgotByLang.ja,
  ...panelAgentDashboardByLang.ja,
  ...panelAgentReferralsByLang.ja,
  ...panelAgentCommissionsByLang.ja,
  ...panelAgentWithdrawByLang.ja,
  ...panelAgentWithdrawUnlockStringsByLang.ja,
  'agent.withdraw.unlock.loadingTitle': '出金ステータスを確認中…',
  'agent.withdraw.unlock.loadingSubtitle': '紹介の進捗と解除要件を読み込んでいます',
  'agent.withdraw.form.loadingTitle': '出金情報を読み込み中…',
  'agent.withdraw.form.loadingHint': '残高と解除ステータスの読み込みが完了するまでお待ちください',
  'agent.withdraw.unlock.requirementMet': '要件を達成',
  'agent.withdraw.unlock.minDepositHint':
    '紹介ユーザーのみが対象（サブエージェントは除く）。各ユーザーは完了済み入金が少なくとも ${{amount}} 必要です。',
  ...panelAgentTransactionsByLang.ja,
  ...panelAgentLogsByLang.ja,
  ...panelAgentSettingsByLang.ja,
  ...panelAgentNotificationsByLang.ja,
  ...panelAgentTeamByLang.ja,
  ...panelAgentSignupByLang.ja,
  ...panelAgentLayoutByLang.ja,
  ...panelAgentAuthByLang.ja,
  ...panelUserPlatformTodayByLang.ja,
  ...panelStopLossHowLayoutByLang.ja,
  ...panelSupportTicketsByLang.ja,
});
